import { Link } from 'react-router';
import { CopyField } from '../components/CopyField';
import { GcpSection } from './connections/GcpSection';
import { RunPodSection } from './connections/RunPodSection';
import { StorageSection } from './connections/StorageSection';

/** How to connect Couch with Claude and with cloud providers (doc 54). Keys and logins stay on the user's devices. */
export function ConnectionsPage() {
  const mcp = `${window.location.origin}/api/v1/mcp`;
  return (
    <div className="connections">
      <h1>Connections</h1>
      <p className="muted">How to use Couch from Claude, and how to add a cloud GPU. Logins and keys stay on your devices — unless you choose to keep a cloud key on Couch.</p>

      <section className="panel" aria-labelledby="claude-app-title">
        <h2 id="claude-app-title">Claude app (desktop, web, phone)</h2>
        <p>Settings → Connectors → Add custom connector, and paste this URL. Claude then asks you here to allow it — no token to copy.</p>
        <CopyField value={mcp} label="Connector URL" />
      </section>

      <section className="panel" aria-labelledby="claude-code-title">
        <h2 id="claude-code-title">Claude Code (terminal)</h2>
        <p>Add Couch, then type <code>/mcp</code> in Claude Code, choose couch → Authenticate, and allow it here.</p>
        <CopyField value={`claude mcp add --transport http couch ${mcp}`} label="Add Couch to Claude Code" />
        <p>Or with an API token instead of signing in (<Link to="/account">API tokens</Link> in Account):</p>
        <CopyField value={`claude mcp add --transport http couch ${mcp} --header "Authorization: Bearer YOUR_API_TOKEN"`} label="Add Couch with an API token" />
      </section>

      <RunPodSection />

      <GcpSection />

      <StorageSection />

      <section className="panel" aria-labelledby="coming-title">
        <h2 id="coming-title">Coming next</h2>
        <ul>
          <li>Google Cloud machines created by Couch — the key is ready above; New cloud machine follows.</li>
          <li>The model library and the archive of originals in your bucket — the key is ready above.</li>
        </ul>
      </section>
    </div>
  );
}
